var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-slide"},[(_vm.visible)?_c('div',{staticClass:"video-width"},[_c('div',{staticClass:"video-aspect"},[_c('div',{staticClass:"video-make-height"},[_c('div',{staticClass:"video-hide-controls"},[_c('iframe',{attrs:{"src":_vm.endPoint,"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])])])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1585d95e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/VideoSlide.vue
// module id = kGoC
// module chunks = 1